export default "__VITE_ASSET__d04298e1__"